import {gql} from '@apollo/client';

export const GET_AVAILABLE_TASKS_FOR_TRANSFER = gql`
    query GetAvailableTasksForTransfer($warehouseId: Long!, $taskDate: String!, $excludeTaskId: Long) {
        getAvailableTasksForTransfer(warehouseId: $warehouseId, taskDate: $taskDate, excludeTaskId: $excludeTaskId) {
            id
            taskNumber
            taskDate
            status
            startPointType
            startPointValue
            endPointType
            endPointValue
            vehicleModelId
            vehicleModelName
            vehicleTypeId
            vehicleTypeName
            expDepartureTime
            actDepartureTime
            expCompleteTime
            actCompleteTime
            warehouseName
            driverName
            vehicleLicensePlate
            appointmentCount
            completedAppointments
            quantityByUnit
            loadRate
        }
    }
`;

export interface AvailableTaskForTransfer {
    id: number;
    taskNumber: string;
    taskDate: string;
    status: string;
    startPointType: number;
    startPointValue: number;
    endPointType: number;
    endPointValue: number;
    vehicleModelId: number;
    vehicleModelName: string | null;
    vehicleTypeId?: number | null;
    vehicleTypeName?: string | null;
    expDepartureTime: string;
    actDepartureTime: string | null;
    expCompleteTime: string | null;
    actCompleteTime: string | null;
    warehouseName: string | null;
    driverName: string | null;
    vehicleLicensePlate: string | null;
    appointmentCount: number;
    completedAppointments: number;
    quantityByUnit: string;
    loadRate: string;
} 